import React, { useState } from 'react';
import styles from '../../../styles/hardware-partners/hardwarePartner.module.css';
import { AdvanceAnalyticsBanner, BlackCustomButton, HardwareFeatures, HardwareTab, MarqueeComponentHomePage, Tabs, TransparentCustomButton, WhiteCustomButton } from '@/components/qbStrap';
import Image from 'next/image';
import OutletFeatures from '@/components/common/OutletFeatures';
import { ClientsArr1, testimonialData, payuFAQ, videoTestimonial, payuFeatures , getTitleContent } from '@/constants/common';
import ThreeStepForm from '@/components/common/ThreeStepForm';
import TestimonialSection from '@/components/common/TestimonialSection';
import TrustFactor from '@/components/common/TrustFactor';
import FrequentQuestions from '@/components/homePage/FrequentQuestions';
import PersonalisedDemoBanner from '@/components/common/PersonalisedDemoBanner';
import VerificationPopup from '@/components/modals/VerificationPopup';
import { useRouter } from 'next/router';
import content from '../../../language/ENGLISH.json';

const DesktopPayU = () => {

    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const router = useRouter();

    const { commonMarqueTitle } = getTitleContent();

    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section}>
                <div className={styles.text_container}>
                    <div className={styles.hardware_logo} style={{ width: "11rem"}}><Image src="/assets/payment-partners/payu/payu.webp" alt="payU" fill /></div>
                    <h1 className={styles.page_heading}>
                        <span className={styles.small_black_text}>Top-Notch POS Transactions</span><br />
                        <span className={styles.black_text}>With</span><span className={styles.blue_text}> PayU global payment solutions</span>
                    </h1>
                    <p className={styles.page_desc}>QueueBuster POS business solution facilitates exceptional transactions integrated with PayU’s robust and innovative digital payment gateway.</p>

                    <div className={styles.btn_container}>
                        <BlackCustomButton text="Try It Free" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("14 Days free trial"))} />
                        <TransparentCustomButton text="Contact Sales" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("Contact Sales"))} />
                    </div>
                </div>
                <div className={styles.hero_img} style={{ height: "45rem", width: "80rem" }}><Image src="/assets/payment-partners/payu/hero-img.webp" alt="PayU" fill /></div>
            </div>

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.portable_devices}>
                <h2>Sell Securely with PayU and QueueBuster POS Billing Solution</h2>
                <HardwareFeatures features={payuFeatures} setDemoModal={setDemoModal} setHeading={setHeading} />
            </div>
            <AdvanceAnalyticsBanner setDemoModal={setDemoModal} setHeading={setHeading} />
            <div style={{ margin: "0 9.3rem" }}><ThreeStepForm /></div>

            <div style={{ margin: "5rem 6rem" }}><TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /></div>
            <TrustFactor />

            <FrequentQuestions FaqTableData={payuFAQ} heading={"FAQs on How PayU works flawlessly on QueueBuster POS Billing Software"} />
            <div style={{ margin: "0 9.3rem" }}><PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} /></div>
        </>
    )
}

export default DesktopPayU